import { ClientConfig } from 'client/configuration';
import { featureFlags } from 'client/utils/feature-flags';
import * as sessionReplay from '@amplitude/session-replay-browser';
import * as analytics from '@amplitude/analytics-browser';
import { isE2ETest } from 'site-modules/financing/utils/financing-utils';
import { requestContext } from 'client/utils/request-context/request-context';
import { logger } from 'client/utils/logger/logger';
import { ExperimentUtil } from 'client/utils/experiment/experiment-util';

const eventType = 'session_replay_link';

export async function initAmplitude(state) {
  const campaignName = 'plat-4390';

  const isAmplitudeEnabled = featureFlags.get('amplitude');
  const clientIsBot = requestContext.get('loggerMetadata')?.isBot;
  const plat4390 = ExperimentUtil.getForcedOrAssignedRecipeName({
    state,
    campaignName,
    defaultVal: 'ctrl',
  });
  const isPlat4390Enabled = plat4390 === 'chal';

  ExperimentUtil.markRecipeUsed({ campaignName, usedRecipeName: plat4390 });

  if (isAmplitudeEnabled && isPlat4390Enabled && !isE2ETest(location) && !clientIsBot) {
    const { id: deviceId, session: sessionId, isNewSession } = state.visitor;
    const { xApiKey } = ClientConfig.get('amplitude');

    try {
      await sessionReplay.init(xApiKey, {
        deviceId,
        sessionId,
      }).promise;

      if (isNewSession) {
        try {
          const sessionReplayId = `${deviceId}/${sessionId}`;
          const amplitudeClient = analytics.createInstance();

          amplitudeClient.init(xApiKey, deviceId, {
            deviceId,
            sessionId,
          });

          const eventProperties = {
            '[Amplitude] Session Replay ID': sessionReplayId,
          };
          const eventOptions = {
            device_id: deviceId,
            session_id: sessionId,
          };

          const result = await amplitudeClient.track(eventType, eventProperties, eventOptions).promise;

          if (result.code !== 200) {
            const { code, message, body } = result;
            logger.warn({ code, message, details: body?.error }, 'Failed to send track event.');
          }
        } catch (error) {
          logger.error(error, 'Failed to send track event: An unexpected error occurred');
        }
      }
    } catch (error) {
      logger.warn(error, 'Failed to initialize sessionReplay');
    }
  }
}
